import type { FC } from 'react';
import { useId, useMemo } from 'react';
import { Box } from '@mui/material';

import type { DashboardWidgetProps } from 'src/types/dashboard';
import useGuidedTour from 'src/components/app/context/GuidedTourContext';
import { useStatistics } from 'src/components/dashboard/DashboardContext/StatisticsContext';
import BaseResponseRateWidget from 'src/components/dashboard/DashboardPage/widgets/ResponseRateWidget/BaseResponseRateWidget';

const ResponseRateWidgetLegacy: FC<DashboardWidgetProps> = ({
  className,
  config,
}) => {
  const ariaId = useId();
  const { data, ...queryResult } = useStatistics();
  const result = data?.focal_result || undefined;
  const { createStep } = useGuidedTour();
  const guidedTour = useMemo(
    () => createStep(config.id, config.guided_tour_step),
    [config.guided_tour_step],
  );

  const {
    dataline: { response_rate, headcount, returns },
  } = result || { dataline: {} };

  return (
    <Box
      aria-labelledby={ariaId}
      sx={{ p: 2, flexGrow: 1, maxWidth: '100%', position: 'relative' }}
    >
      {!!guidedTour && (
        <Box sx={{ position: 'absolute', top: 0, left: 0 }}>{guidedTour}</Box>
      )}
      <BaseResponseRateWidget
        ariaId={ariaId}
        {...queryResult}
        className={className}
        aggregate={{
          totalValue: headcount,
          relativeValue: response_rate,
          absoluteValue: returns,
        }}
        name={config.name}
      />
    </Box>
  );
};

export default ResponseRateWidgetLegacy;
